export const PRESETS = {
  card: {
    body: {
      bottom: -0.5,
    },
  },
};
